import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-satisfaction-config-card',
  templateUrl: './satisfaction-config-card.component.html',
  styleUrls: ['./satisfaction-config-card.component.scss']
})
export class SatisfactionConfigCardComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}

